
export interface CategorizationResult {
  category: string;
  estimatedPrice: string;
  clarifyingQuestions: string[];
}

/**
 * A rule-based local categorization engine to handle requests without external API calls.
 * This is faster, works offline, and fulfills the "Keyword Rules" MVP requirement.
 */
export const categorizeRequestLocal = (text: string): CategorizationResult => {
  const lowercaseText = text.toLowerCase();
  
  // Define categories and their keyword mappings
  const rules = [
    {
      category: 'Tailor',
      keywords: ['zipper', 'rip', 'torn', 'dress', 'pants', 'hem', 'stitch', 'sew', 'alter', 'fit', 'clothes', 'fabric'],
      price: '$25 - $60',
      questions: ['What is the fabric type?', 'How quickly do you need the garment back?']
    },
    {
      category: 'Locksmith',
      keywords: ['lock', 'key', 'jammed', 'door', 'entrance', 'bolt', 'stuck', 'entry', 'unlock', 'safe'],
      price: '$80 - $150',
      questions: ['Is it a standard cylinder lock or a deadbolt?', 'Do you have the original key?']
    },
    {
      category: 'Carpenter',
      keywords: ['wood', 'table', 'chair', 'furniture', 'mahogany', 'joinery', 'shelf', 'carve', 'cabinet', 'oak'],
      price: '$100 - $400',
      questions: ['Can you provide dimensions?', 'Are we matching an existing wood finish?']
    },
    {
      category: 'Hair Stylist',
      keywords: ['hair', 'cut', 'stylist', 'braids', 'wig', 'color', 'trim', 'barber', 'shampoo', 'silk press'],
      price: '$45 - $200',
      questions: ['What is your current hair length?', 'Are you looking for a specific style or a routine trim?']
    },
    {
      category: 'Plumber',
      keywords: ['pipe', 'leak', 'drain', 'toilet', 'sink', 'faucet', 'clog', 'water', 'shower'],
      price: '$90 - $250',
      questions: ['Is the leak constant or only when the water is running?', 'Is the area accessible?']
    }
  ];

  // Find the first matching rule based on keywords
  const match = rules.find(rule => 
    rule.keywords.some(keyword => lowercaseText.includes(keyword))
  );

  if (match) {
    return {
      category: match.category,
      estimatedPrice: match.price,
      clarifyingQuestions: match.questions
    };
  }

  // Fallback for general requests
  return {
    category: "General Maintenance",
    estimatedPrice: "$50 - $150",
    clarifyingQuestions: ["Can you provide more specific details about the materials involved?", "When would you like this project to start?"]
  };
};
